import React from 'react';
import { FaChevronDown } from "react-icons/fa";
import { DataCell } from '../../rectificationRefund/selectRefundReasonAndReceipt/StudentDetails';
import styles from "../styles.module.scss";
import { formattedPrice } from '../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { useNavigateToGivenPath } from '../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/service';
import AAccordion from '../../../../../components/AAccordion/AAccordion';


const StudentDetails = ({
    studentDetails,
    labelFieldMappings,
}) => {

    const { studentLoanDetails = {}, psid } = studentDetails;
    const { isLoanCase, loanScheme = {}, netLoanAmount } = studentLoanDetails;
    const { vendorName } = loanScheme;

    const navigateToGivenPath = useNavigateToGivenPath();


    return (
        <AAccordion expandIcon={<FaChevronDown/>}>

                <h3 className='m-0'>Student Details</h3>

                <div className='d-flex flex-column mt-2' style={{ gap: '1rem' }}>

                    <div className={`${styles['student-details-grid']}`}>
                        {labelFieldMappings?.map(el => {
                            const { label, field, renderExtra } = el;
                            return (
                                <DataCell
                                    label={label}
                                    value={studentDetails[field]}
                                    key={field}
                                >
                                    {renderExtra}
                                </DataCell>
                            )
                        })}

                    </div>

                    {isLoanCase &&
                        <div className={styles['student-loan-details']}>
                            <div className={styles['vendor-name']}>{vendorName}</div>
                            <div className={styles['loan-amount']}>Total loan amount <b>{formattedPrice(netLoanAmount)}</b></div>
                        </div>
                    }

                    <AButton
                        variant='link'
                        // size='xs'
                        className='no-ml-btn align-self-start'
                        onClick={() => navigateToGivenPath(`admin/edp/studentDetails/${psid}`)}
                    >
                        Student Dashboard
                    </AButton>

                </div>

        </AAccordion>
    );
}

export default StudentDetails;